import React, { Fragment } from 'react';
import { Card } from "react-bootstrap";
import adminPortalBackground from "../images/adminPortalBackground.png";
import logoImage from "../images/IGC_Logo.png";
import configInfo from '../config/config.json';
import { useTranslation } from "react-i18next";

const Dashboard = () => {

  const { t } = useTranslation(["common"]);

  return (
    <Fragment>

      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px',
            height:'850px', width:'100%', backgroundImage: `url(${adminPortalBackground})` }}>

        <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}>
          <span style={{fontSize: '50px', color: '#307CE1'}} >BuildingOS Admin Portal</span>
          <span style={{fontSize: '12px', color: 'gray'}}>{t("I18N_Version")}: {configInfo.versionInfo.version}</span>
          <span style={{fontSize: '12px', color: 'gray'}}>{t("I18N_Time_built")}: {configInfo.versionInfo.timeBuilt}</span>
        </div>
        <div style={{ display: 'flex' }}>
          <span style={{marginLeft: 'auto', marginTop: '1px', fontSize: '15px', color: 'gray'}} >Powered by </span>
          <span style={{marginLeft: '5px', marginRight: '0px', fontSize: '15px', color: 'gray'}} >
            <img
              src={logoImage}
              width={35}
              alt={"SHKP"}
            />
          </span>
        </div>

      </Card>


    </Fragment>
  )
}

export default Dashboard;
